import styled, { RuleSet } from 'styled-components'
import { Noto_body1_r16 } from 'src/styles/font/NotoSansKrFonts'

interface FormInputProps {
  error?: boolean
  disabled?: boolean
  $style?: RuleSet<object>
  autoComplete?: string
}
export const FormItem = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
`
export const FormInputWrap = styled.div`
  width: 100%;
  position: relative;
`
export const FormInput = styled.input<FormInputProps>`
  ${Noto_body1_r16};
  width: 100%;
  border-radius: 12px;
  padding: 12px 16px;
  border: 1px solid ${(props) => (props.error ? 'red' : 'var(--black-20)')};
  background-color: ${(props) => (props.error ? 'var(--black-2)' : 'var(--white)')};
  color: ${({ disabled }) => (disabled ? 'var(--black-20)' : 'var(--black-100)')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &::placeholder {
    color: var(--black-40);
  }
  &:focus {
    border: 1px solid var(--black-70);
    background-color: var(--black-2);
  }

  ${(props) => props.$style};
`
